import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'error' | 'success' | 'info';
export interface Toast { id: number; type: ToastType; message: string; }

/**
 * Lightweight global toast stack for the public site. Messages should already be
 * localized by the caller (the interceptor builds EN/AR strings itself).
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts$ = new BehaviorSubject<Toast[]>([]);
  readonly toasts$ = this._toasts$.asObservable();
  private seq = 0;

  show(message: string, type: ToastType = 'info', timeoutMs = 5000): void {
    const id = ++this.seq;
    this._toasts$.next([...this._toasts$.value, { id, type, message }]);
    if (timeoutMs > 0) setTimeout(() => this.dismiss(id), timeoutMs);
  }

  error(message: string): void { this.show(message, 'error'); }
  success(message: string): void { this.show(message, 'success'); }
  info(message: string): void { this.show(message, 'info'); }

  dismiss(id: number): void {
    this._toasts$.next(this._toasts$.value.filter((t) => t.id !== id));
  }
}
